import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'agingreport',
  components: {
    Paginate,
    VueElementLoading,
    Multiselect
  },
  props: [],

  data() {
    return {
      
      // CODLedgerReports: [],
      zone: '',
      // zoneIdArr: [],
      resultCount: '',
      toDate: "",
      fromDate: "",
      status: "",
      hubname: "",
      pageno: 0,
      pagecount: 0,
      isLoading: false,
      exportf: false,
      disableHub: false,
      disableRSCOwner: false,
      zoneLoading: false,
      hubLoading: false,
      role: '',
      cluster: '',
      clusterList: [],
      state: '',
      stateList: [],
      hub:'',
      hubType:'',
      locationList: [],
      stateLoading: false,
      clusterLoading: false,
      hubtypeLoading:false,
      tillDate: '',
      hubIdArray:[],
      allZoneLoading:false,
      zoneList:[],
      locationTypeList:[]

    }
  },


  mounted() {
    var date = new Date();
    tillDate.max = date.toLocaleDateString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });

    var userToken = window.localStorage.getItem('accessuserToken')
    this.myStr = userToken.replace(/"/g, '');

    this.role = window.localStorage.getItem('accessrole').toLowerCase().replace(/\s/g, '');

    this.getRMData();
    this.getLocationType();
    this.getStateData();
    this.getClusters();
  },

  methods: {

     getRMData() {
      this.input = {}; this.zoneList = []; this.allZoneLoading = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url + 'fetchRms',
          data: this.input,
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {
          if(result.data.code==200){
            this.allZoneLoading = false;
            this.zoneList = result.data.data;
          }else{
            this.allZoneLoading = false;
            this.$alertify.error(result.data.message);
          }
        }, error => {
          this.allZoneLoading = false; this.HubId = this.hubList = []; console.error(error);
        })
    },


    getLocationType() {
      this.input = {}; this.locationTypeList = []; this.hubtypeLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'getLocationType',
          data: this.input,
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {
          if(result.data.code==200){
            this.hubtypeLoading = false;
            this.locationTypeList = result.data.data;
          }else{
            this.hubtypeLoading = false;
            this.$alertify.error(result.data.message);
          }
        }, error => {
          this.hubtypeLoading = false; this.locationTypeList = []; console.error(error);
        })
    },
    getLocations() {
      this.hub='';
      this.hubList=[];
      this.cluster='';
      this.state='';
      this.hubLoading=true;
      let data = {
        zone_id: this.zone?this.zone:0,
        location_type:this.hubType?this.hubType.location_type:'0'
      };

      // if (this.cluster) {
      //   data.cluster_id = this.cluster.id;
      // }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getLocations',
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        },
        data: data
      })
        .then(result => {
          if (result.data.code == 200) {
            this.locationList  = [{
              location_id: 0,
              location_with_id: 'Select All'
            }, ...result.data.data];
            this.hubLoading=false
          }
        }, error => {
          this.hubLoading = false;
          console.error(error);
          this.$alertify.error('Location Error');
        });
    },

    getStateData() {
      this.stateLoading = true;
      axios({
        method: 'GET',
        url: apiUrl.api_url + 'getAllStates',
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      })
        .then(result => {
          this.stateLoading = false;
          console.log('state data', result);
          if (result.data.code == 200) {
            // this.stateList = [{
            //   state_id: 0,
            //   state_email: 'Select All'
            // }, ...result.data.data];
            this.stateList =result.data.data;
          }
        }, error => {
          this.stateLoading = false;
          console.error(error);
          this.$alertify.error('State Error');
        });
    },
    getClusters() {
      this.clusterLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getClusters',
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        },
        // data: data
      })
        .then(result => {
          this.clusterLoading = false;
          if (result.data.code == 200) {
            // this.clusterList = [{
            //   cluster_id: 0,
            //   cluster_email: 'Select All'
            // }, ...result.data.data];
            this.clusterList = result.data.data;
          }
        }, error => {
          this.clusterLoading = false;
          console.error(error);
          this.$alertify.error(error);
        });
    },

    onClusterChange() {
      this.zone=''
      this.hub=''
      this.hubType=''
      this.state = '';
      // this.getLocations();
    },
    onStateChange() { 
      this.zone=''
      this.hub=''
      this.hubType=''
      this.cluster = '';
    },
    onhubTypechange(){
      this.cluster = '';
      this.zone=''
      this.hub=''
      this.state=''
    },

    multipleCluster() {
      let key = this.cluster ? this.cluster.length - 1 : 0;
      if (this.cluster.length > 0 && this.cluster[key].id == 0) {
        this.SearchClusterIds = [];
        this.cluster = this.cluster[key];

        for (let item of this.clusterList) {
          if (item.id != 0) {
            this.SearchClusterIds.push(item.id);
          }
        }
      }

      if (this.cluster.id == 0) {
        return false;
      } else {
        this.SearchClusterIds = [];
        return false;
      }
    },

    // multipleState() {
    //   let key = this.state ? this.state.length - 1 : 0;
    //   if (this.state.length > 0 && this.state[key].id == 0) {
    //     this.SearchStateIds = [];
    //     this.state = this.state[key];

    //     for (let item of this.stateList) {
    //       if (item.id != 0) {
    //         this.SearchStateIds.push(item.id);
    //       }
    //     }
    //   }

    //   if (this.state.id == 0) {
    //     return false;
    //   } else {
    //     this.SearchStateIds = [];
    //     return false;
    //   }
    // },


   

   

   

    onSubmit: function (event) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if( !this.tillDate){
        this.$alertify.error('Please select date.');
        return;
      }
      if (!this.tillDate.match(dateRegex) ) {
        this.$alertify.error('Invalid date format. Please use YYYY-MM-DD.');
        return;
      }

      if (!this.zone && !this.state  && !this.cluster && !this.hubType && !this.hub) {
        this.$alertify.error('Please select an option from the dropdown field.');
        return;
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getLocations',
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        },
        
        
        data: {
          state_id:this.state.id?this.state.id:0,
          cluster_id:this.cluster.id?this.cluster.id:0,
          zone_id:this.zone?this.zone:0,
          location_type:this.hubType?this.hubType.location_type:'0',
          location_id:this.hub?this.hub.location_id:0
        }
      })
        .then(result => {
          if (result.data.code == 200) {
           let hubData=result.data.data;
           let hubarray=[];
           hubData.map(e=>{
             hubarray.push(e.location_id)
           });
           this.hubIdArray=hubarray;
           console.log(this.hubIdArray,">>>>>>>>>>>");
           this.exportOutstandingReports();
          }else{
            this.$alertify.error("No such combinations");
          }
        }, error => {
          console.error(error);
          this.$alertify.error(error);
        });
      
    },

    exportOutstandingReports() {
      console.log(this.hubIdArray);
      
      let data = {
        todate: this.tillDate,
        hubid: this.hubIdArray,
      };

      data.todate = new Date(this.tillDate).toISOString().split("T")[0];

      // if (this.locationList.length > 0) {
      //   for (let item of this.locationList) {
      //     data.hubid.push(item.location_id);
      //   }
      // }
      this.isLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'exportOustandingReports',
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        },
        data: data
      })
        .then(result => {
          this.isLoading = false;
          if (result.data.code == 200) {
            this.reportlink = result.data.data;
              window.open(this.reportlink);
            this.$alertify.success('Export Successful');
            this.isLoading=false
          }
        }, error => {
          console.error(error);
          this.$alertify.error('Export Error');
          this.isLoading = false;
        });
    },
    resetForm(){
      this.tillDate="";
      this.cluster="";
      this.state="";
      this.zone='';
      this.hub='';
      this.hubType='';
      this.isLoading=false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/agingreport/agingreport.component.js